export default __webpack_public_path__ + "static/media/calculator_preview.da4e7120.png";